import { SearchParameters, useSearchParameters } from '../useSearchParameters'

const useDebug = () => {
  const params = useSearchParameters()

  return params[SearchParameters.DEBUG] === 'true'
}

export { useDebug }
